const translations = {
  en: {
    common: {
      comingSoon: 'Coming soon',
      skipToContent: 'Skip to main content',
      harvestImageAlt: 'Hazelnut harvest',
      orchardImageAlt: 'Hazelnut orchard'
    },

    header: {
      language: 'English',
      cart: 'Cart',
      search: 'Search',
      promo:
        '🌰 Fresh Hazelnuts from Our Orchard • Free delivery on orders of 10 kg or more',
      newProductsLink: 'Shop organic hazelnuts',
      toggleMenu: 'Toggle menu',
      logoAria: 'deezNuts home',
      mobileLang: 'Language',
      navHome: 'Home',
      navAbout: 'Our Orchard',
      navAllProducts: 'All Products',
      navFreshHazelnuts: 'Organic Hazelnuts',
      navHazelnutSnaps: 'Hazelnut Snaps',
      navWhiteTruffles: 'White Truffles',
      navGiftBoxes: 'Gift Boxes',
      navLabel: 'Main navigation',
      close: 'Close',
      themeDark: 'Switch to dark mode',
      themeLight: 'Switch to light mode',
      mobileTheme: 'Theme'
    },

    hero: {
      tagline: 'Not just another bag of nuts.',
      mainTitle: 'Fresh Organic Hazelnuts',
      description:
        'Certified organic in-shell hazelnuts in breathable jute bags — naturally dried, raw and unroasted, from our family orchard.',
      premiumHazelnutsAlt: '10 kg jute bag of in-shell organic hazelnuts',
      cta: 'Shop hazelnuts'
    },

    about: {
      label: 'Our Story',
      title: 'Cultivated with Love, Harvested with Pride',
      paragraph1:
        'In our orchard, every tree has a name and every harvest is a celebration. We sell raw in-shell hazelnuts, naturally dried in the sun — never roasted — so you taste the nut as it came off the tree.',
      paragraph2:
        "Our family's dedication to sustainable organic farming ensures that you taste not just a hazelnut, but the love and labor of a family united by a passion for quality.",
      button: 'Meet the Nuts',
      timelineButton: 'Explore Timeline (2018–2026)',
      highlights: [
        '🌱 ~1,100 Hazelnut Trees',
        '✅ Organic RO-ECO-023',
        '🌰 Tonda Gentile Romana & Halle\'s Giant'
      ]
    },

    categories: {
      title: 'Discover Our Hazelnut Products',
      snaps: {
        title: 'Hazelnut Snaps',
        subtitle: '250 ml · 500 ml · 1 L'
      },
      hazelnuts: {
        title: 'Organic Hazelnuts',
        subtitle: 'In-shell · Jute bags'
      },
      truffles: {
        title: 'White Truffles',
        subtitle: '50 g · 100 g · 300 g'
      },
      gifts: {
        title: 'Gift Boxes',
        subtitle: 'Perfect Presents'
      }
    },

    sections: {
      hazelnuts: {
        title: 'Organic Hazelnuts',
        description:
          'Certified organic in-shell hazelnuts in breathable jute bags — 45 lei/kg, from 5 kg to 20 kg.'
      },
      snacks: {
        title: 'Hazelnut Snaps',
        description:
          'Hazelnut spirit in 250 ml, 500 ml, and 1 L bottles. Coming soon.'
      },
      truffles: {
        title: 'White Truffles',
        description:
          'White truffles (Tuber Magnatum) in 50 g, 100 g, and 300 g. Coming soon.'
      },
      gifts: {
        title: 'Gift Boxes',
        description: 'Curated hazelnut experiences for everyone you love.'
      }
    },

    product: {
      addToCart: 'Add to Cart',
      bestseller: 'Bestseller',
      new: 'New',
      reviewsWord: 'reviews',
      notFound: 'Product not found.',
      backToProducts: 'Back to products',
      back: '← Back',
      freeShippingFeature: 'Free delivery on orders of 10 kg or more',
      freshFromOrchard: 'Fresh from our orchard',
      premiumQuality: 'Premium quality',
      juteBag: 'Jute bag',
      perKg: '/ kg',
      orderNow: 'Order',
      selectBagSize: 'Select bag size',
      orderByMessage: 'Order by message',
      orderByWhatsApp: 'WhatsApp',
      orderByFacebook: 'Facebook',
      orderByEmail: 'Order by email',
      orderByPhone: 'Order by phone',
      orderEmailSubject: 'Order inquiry: {product}',
      orderEmailBodyIntro: 'Hello,\n\nI would like to order:',
      comingSoonNote:
        'This product is not available to order yet. Contact us if you want to be notified when it launches.',
      hazelnutCert: 'Organic certificate RO-ECO-023.642-0006300.2026.001',
      hazelnutRaw: 'Raw in-shell hazelnuts, naturally dried, unroasted',
      hazelnutDelivery: 'Free courier delivery on orders of 10 kg or more',
      hazelnutPickup: 'Personal pickup in Dumbrăvița, Timiș County',
      hazelnutSeller: 'Seller: Adrian Ciuca — family farm',
      provenanceTitle: 'From our orchard',
      imagePrev: 'Previous product image',
      imageNext: 'Next product image'
    },

    productsPage: {
      allProducts: 'All Products',
      bestsellers: 'Bestsellers',
      newProducts: 'New Products',
      hazelnuts: 'Organic Hazelnuts',
      snacks: 'Hazelnut Snaps',
      truffles: 'White Truffles',
      gifts: 'Gift Boxes',
      searchPlaceholder: 'Search products...',
      filterSort: 'Filter and sort',
      products: 'products',
      noProducts: 'No products found.',
      defaultSort: 'Default sorting',
      sortName: 'Sort by name',
      priceLowHigh: 'Price: Low to High',
      priceHighLow: 'Price: High to Low',
      sortRating: 'Sort by rating',
      searchAria: 'Search products',
      searchClear: 'Clear search'
    },

    cartPage: {
      title: 'Shopping Cart',
      empty: 'Your cart is currently empty.',
      continueShopping: 'Continue Shopping',
      freeShipping: "Congratulations! You've earned free delivery!",
      addMore: 'more for free delivery',
      addPrefix: 'Add ',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      free: 'Free',
      total: 'Total',
      checkout: 'Checkout',
      removeItem: 'Remove item',
      qtyDecrease: 'Decrease quantity',
      qtyIncrease: 'Increase quantity',
      checkoutWhatsApp: 'Send order on WhatsApp',
      checkoutEmail: 'Send order by email',
      orderSummaryHeading: 'Order request — deezNuts',
      orderSellerLabel: 'Seller',
      orderSellerName: 'Adrian Ciuca',
      orderPickupLabel: 'Pickup / delivery',
      orderPickupPlace: 'Personal pickup in Dumbrăvița, Timiș County, or courier delivery',
      checkoutEmailSubject: 'Order request — deezNuts'
    },

    contactPage: {
      title: 'Contact',
      intro: 'Email us at',
      orCall: 'or call',
      phoneLabel: 'Phone',
      getInTouch: 'Get in Touch',
      email: 'Email',
      orchard: 'Orchard',
      location: 'Dumbrăvița, Timiș County — personal pickup or courier delivery',
      nameLabel: 'Name',
      emailLabel: 'Email',
      messageLabel: 'Message',
      sendButton: 'Open in WhatsApp',
      sendEmail: 'Open in email',
      nameRequired: 'Please enter your name.',
      emailRequired: 'Please enter your email.',
      emailInvalid: 'Please enter a valid email address.',
      messageRequired: 'Please enter a message.',
      openedWhatsApp:
        'Your message was opened in WhatsApp. Review it and tap Send — we have not received it until you do.',
      openedEmail:
        'Your message was opened in your email app. Review it and send — we have not received it until you do.',
      popupBlocked: 'Your browser blocked the new window. Use this link instead:',
      whatsappLinkLabel: 'Open WhatsApp',
      emailLinkLabel: 'Open email'
    },

    footer: {
      products: 'Products',
      hazelnuts: 'Organic Hazelnuts',
      truffles: 'White Truffles',
      snacks: 'Hazelnut Snaps',
      spreads: 'Spreads & Butters',
      baking: 'Baking Ingredients',
      gifts: 'Gift Boxes',
      info: 'Information',
      contact: 'Contact Us',
      about: 'About Our Orchard',
      blog: 'Blog',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
      contactTitle: 'Contact',
      newsletter: 'Subscribe to Our Newsletter',
      newsletterText: 'Get exclusive offers and fresh hazelnut updates!',
      subscribe: 'Subscribe',
      thankYou: 'Thank you for subscribing!',
      copyright: '© {year} deezNuts. All rights reserved.',
      tagline: '🌰 Organic hazelnuts from our orchard, planted since 2018',
      sellerName: 'Adrian Ciuca',
      sellerSubtitle: 'Family farm · Dumbrăvița, Timiș County',
      addressLine1: 'Dumbrăvița, Timiș County',
      addressLine2: 'Personal pickup or courier delivery'
    },

    aboutPage: {
      eyebrow: 'Our orchard · Since 2018',
      heroTitle: 'Our orchard, since 2018',
      heroSubtitle:
        '~2 ha, ~1,100 hazelnut trees — Tonda Gentile Romana and Halle\'s Giant — certified organic',
      heroPills: [
        '🌱 379 trees (2018) → ~1,100 today',
        '💧 Drip irrigation',
        '✅ Organic Certified RO-ECO-023'
      ],
      scrubberLabel: 'Explore orchard years',
      openPhotoLabel: 'Open photo',
      galleryCountLabel: 'photos',
      lightboxClose: 'Close gallery',
      lightboxPrev: 'Previous photo',
      lightboxNext: 'Next photo',
      timeline: [
        {
          year: '2018',
          title: 'First 379 hazelnut trees',
          story:
            'In the summer of 2018 we planted the first 379 hazelnut trees on our land. Each seedling got its protective tube, and in the first months the first leaves appeared.',
          badges: ['🌱 379 trees planted'],
          alt: 'Hazelnut seedlings in protective tubes in our orchard, 2018'
        },
        {
          year: '2019',
          title: 'The orchard takes root',
          story:
            'The first-year seedlings took hold, and we maintained the rows all summer. In autumn we planted 60 more trees.',
          badges: ['🌱 +60 trees'],
          alt: 'Maintained rows of young hazelnut trees in our orchard, 2019'
        },
        {
          year: '2020',
          title: 'Another 196 trees',
          story:
            'In the summer of 2020 we planted 196 more hazelnut trees. The first seedlings began to look like bushes, with quiet evenings and sunset over the orchard.',
          badges: ['🌱 +196 trees'],
          alt: 'Young hazelnut bushes at sunset in our orchard, 2020'
        },
        {
          year: '2021',
          title: 'Biggest planting: 600 trees',
          story:
            'In 2021 we planted 600 hazelnut trees, our largest planting to date. The orchard nearly reached its current size.',
          badges: ['🌱 +600 trees'],
          alt: 'Leafy hazelnut orchard in spring and summer, 2021'
        },
        {
          year: '2022',
          title: 'Replacements, poplars, and irrigation',
          story:
            'In spring we replaced lost seedlings and planted about 110 poplar trees. The orchard has drip irrigation, and the first green hazelnuts appeared on the bushes.',
          badges: ['🌳 ~110 poplars', '💧 Drip irrigation'],
          alt: 'First green hazelnuts on bushes and drip irrigation, 2022'
        },
        {
          year: '2023',
          title: 'Bushes in full strength',
          story:
            'The bushes filled in, and the rows already look like a real orchard. By autumn, the first hazelnuts were in our palm.',
          badges: ['🌿 Established orchard'],
          alt: 'Dense hazelnut rows and first hazelnuts in hand, 2023'
        },
        {
          year: '2024',
          title: 'First harvest',
          story:
            'In 2024 we had our first real harvest. Hazelnuts fall under the bushes, and we gather them with the Cifarelli harvester.',
          badges: ['🌰 First harvest'],
          alt: 'First hazelnut harvest in our orchard, 2024'
        },
        {
          year: '2025',
          title: 'Second harvest',
          story:
            'The second harvest came with an ever-growing orchard. In autumn, the bushes turn yellow before winter.',
          badges: ['🍂 Second harvest'],
          alt: 'Hazelnut orchard in autumn colors after the second harvest, 2025'
        },
        {
          year: '2026',
          title: 'Organic certified and deezNuts',
          story:
            'Our orchard holds organic certificate RO-ECO-023.642-0006300.2026.001 from Mișcarea Română pentru Calitate (RO-ECO-023), valid until 31.12.2027. Hazelnuts are sold under the deezNuts name, with our Facebook page launched in 2026. In May the bushes were full of catkins and young hazelnuts, and in September the harvest filled the crates.',
          badges: [
            '✅ RO-ECO-023.642-0006300.2026.001',
            '📣 deezNuts Facebook launch'
          ],
          alt: 'Certified organic orchard and harvest in crates, 2026'
        }
      ],
      cta: {
        eyebrow: 'Organic Certified RO-ECO-023',
        title: 'Order organic hazelnuts straight from the orchard',
        subtitle:
          'Grown by us, year after year, in certified organic farming — Tonda Gentile Romana and Halle\'s Giant varieties from our orchard.',
        priceBadge: '45 lei / kg · Minimum order 5 kg',
        certBadge:
          'Organic Certificate RO-ECO-023.642-0006300.2026.001 · Mișcarea Română pentru Calitate (RO-ECO-023) · Valid until 31.12.2027',
        primaryBtn: 'Order organic hazelnuts',
        phoneBtn: 'Call: +40 736 917 034'
      }
    },

    static: {
      blogTitle: 'Blog',
      blogBody: 'Our latest stories are coming soon.',
      termsTitle: 'Terms and Conditions',
      privacyTitle: 'Privacy Policy',
      termsParagraphs: [
        'deezNuts is a small family hazelnut orchard operated by Adrian Ciuca in Dumbrăvița, Timiș County. There is no registered company (no SRL/PFA) behind this website — orders are handled personally.',
        'Products shown in the cart are order requests, not automatic purchases. Adrian confirms availability, total price, and pickup or delivery details with you by WhatsApp, phone, or email before anything is reserved.',
        'This website does not process card payments and does not create user accounts. The shopping cart is stored only in your browser on your device (local storage) until you clear it or remove items.',
        'Checkout opens WhatsApp or your email app with a prefilled order summary. You must review the message and send it yourself — we do not receive an order until you do.',
        'Courier delivery is available; orders of 10 kg or more qualify for free delivery, as shown in the cart. Personal pickup is in Dumbrăvița, Timiș County.',
        'Contact: use the phone number and email on the Contact page, or message us on WhatsApp or Facebook.'
      ],
      privacyParagraphs: [
        'This site is operated by Adrian Ciuca for the deezNuts family orchard. We do not run user accounts or a payment gateway on this website.',
        'When you use the shopping cart, product choices are saved in local storage in your browser on your device. We do not receive that data unless you send us an order summary via WhatsApp or email.',
        'The contact form does not submit data to our servers. It opens WhatsApp or your email client with the text you entered; you choose whether to send it.',
        'If you contact us by phone, email, WhatsApp, or Facebook, we use your message only to respond about orders, pickup, or delivery. We do not sell your contact details.',
        'For questions about your data or orders, reach Adrian at the email and phone listed on the Contact page.'
      ]
    },

    flappyFish: {
      privacyTitle: 'Privacy Policy — Flappy Fish: Sunbeam Reef',
      lastUpdated: 'Last updated: July 24, 2026',
      intro:
        'Flappy Fish: Sunbeam Reef (“the App”) is a casual mobile game. This page is the privacy policy and support contact for the App.',
      developerLabel: 'Developer',
      contactLabel: 'Contact',
      onDeviceTitle: 'Data we store on your device',
      onDeviceScores:
        'High scores, player name, coin balance, and shop items (hearts/shields) via on-device storage (UserDefaults).',
      onDeviceSettings: 'Game settings such as sound and haptics preferences.',
      gameCenterTitle: 'Game Center',
      gameCenterBody:
        'If you sign in to Game Center, Apple may process your Game Center display name and scores for the global leaderboard. That processing is governed by Apple’s privacy policy. We do not operate a separate account system.',
      notDoTitle: 'What we do not do',
      notDoAccount: 'We do not require creating an account in the App.',
      notDoSell: 'We do not sell personal data.',
      notDoAds:
        'We do not show third-party advertising networks in the current version.',
      notDoSensitive:
        'We do not collect precise location, contacts, photos, or microphone data.',
      childrenTitle: 'Children',
      childrenBody:
        'The App is suitable for a general audience. We do not knowingly collect personal information from children beyond what Apple’s Game Center provides if a player signs in.',
      changesTitle: 'Changes',
      changesBody:
        'We may update this policy; the “Last updated” date will change when we do.',
      supportTitle: 'Support',
      supportBody:
        'For help with Flappy Fish: Sunbeam Reef, email the address below. We usually reply within a few business days.'
    }
  },

  ro: {
    common: {
      comingSoon: 'În curând',
      skipToContent: 'Sari la conținutul principal',
      harvestImageAlt: 'Recoltă de alune',
      orchardImageAlt: 'Livadă de alune'
    },

    header: {
      language: 'Română',
      cart: 'Coș',
      search: 'Căutare',
      promo:
        '🌰 Alune Proaspete din Livada Noastră • Transport gratuit la comenzi de minim 10 kg',
      newProductsLink: 'Cumpără alune ecologice',
      toggleMenu: 'Deschide meniul',
      logoAria: 'Acasă deezNuts',
      mobileLang: 'Limbă',
      navHome: 'Acasă',
      navAbout: 'Livada Noastră',
      navAllProducts: 'Toate Produsele',
      navFreshHazelnuts: 'Alune Ecologice',
      navHazelnutSnaps: 'Țuică de Alune',
      navWhiteTruffles: 'Trufe Albe',
      navGiftBoxes: 'Cutii Cadou',
      navLabel: 'Navigare principală',
      themeDark: 'Comută pe mod întunecat',
      themeLight: 'Comută pe mod luminos',
      mobileTheme: 'Temă',
      close: 'Închide'
    },

    hero: {
      tagline: 'Nu doar o altă punga de alune.',
      mainTitle: 'Alune Organice Proaspete',
      description:
        'Alune ecologice certificate în coajă, în saci de iută respirabili — uscate natural, crude și neprăjite, din livada familiei noastre.',
      premiumHazelnutsAlt: 'Sac de iută 10 kg cu alune ecologice în coajă',
      cta: 'Cumpără alune'
    },

    about: {
      label: 'Povestea Noastră',
      title: 'Cultivate cu Dragoste, Recoltate cu Mândrie',
      paragraph1:
        'În livada noastră, fiecare copac are un nume și fiecare recoltă este o sărbătoare. Vindem alune crude în coajă, uscate natural la soare — neprăjite — ca să simți gustul adevărat al alunei.',
      paragraph2:
        'Dedicarea familiei noastre pentru agricultura ecologică sustenabilă asigură că guști nu doar o alună, ci dragostea și munca unei familii unite de pasiunea pentru calitate.',
      button: 'Descoperă Alunele',
      timelineButton: 'Povestea din livadă (2018–2026)',
      highlights: [
        '🌱 ~1.100 Aluni',
        '✅ Certificat Eco RO-ECO-023',
        '🌰 Tonda Gentile Romana & Halle\'s Giant'
      ]
    },

    categories: {
      title: 'Descoperă Produsele Noastre',
      snaps: {
        title: 'Țuică de Alune',
        subtitle: '250 ml · 500 ml · 1 L'
      },
      hazelnuts: {
        title: 'Alune Ecologice',
        subtitle: 'În coajă · Saci de iută'
      },
      truffles: {
        title: 'Trufe Albe',
        subtitle: '50 g · 100 g · 300 g'
      },
      gifts: {
        title: 'Cutii Cadou',
        subtitle: 'Cadouri Perfecte'
      }
    },

    sections: {
      hazelnuts: {
        title: 'Alune Ecologice',
        description:
          'Alune ecologice certificate în coajă, în saci de iută — 45 lei/kg, de la 5 kg la 20 kg.'
      },
      snacks: {
        title: 'Țuică de Alune',
        description:
          'Țuică de alune, sticle de 250 ml, 500 ml și 1 L. În curând.'
      },
      truffles: {
        title: 'Trufe Albe',
        description:
          'Trufe albe (Tuber Magnatum), 50 g, 100 g și 300 g. În curând.'
      },
      gifts: {
        title: 'Cutii Cadou',
        description: 'Experiențe culinare cu alune pentru toți cei dragi.'
      }
    },

    product: {
      addToCart: 'Adaugă în Coș',
      bestseller: 'Bestseller',
      new: 'Nou',
      reviewsWord: 'recenzii',
      notFound: 'Produsul nu a fost găsit.',
      backToProducts: 'Înapoi la produse',
      back: '← Înapoi',
      freeShippingFeature: 'Transport gratuit la comenzi de minim 10 kg',
      freshFromOrchard: 'Proaspăt din livada noastră',
      premiumQuality: 'Calitate premium',
      juteBag: 'Sac de iută',
      perKg: '/ kg',
      orderNow: 'Comandă',
      selectBagSize: 'Alege mărimea sacului',
      orderByMessage: 'Comandă prin mesaj',
      orderByWhatsApp: 'WhatsApp',
      orderByFacebook: 'Facebook',
      orderByEmail: 'Comandă prin email',
      orderByPhone: 'Comandă telefonic',
      orderEmailSubject: 'Comandă: {product}',
      orderEmailBodyIntro: 'Bună ziua,\n\nAș dori să comand:',
      comingSoonNote:
        'Acest produs nu poate fi comandat încă. Contactează-ne dacă vrei să fii anunțat la lansare.',
      hazelnutCert: 'Certificat ecologic RO-ECO-023.642-0006300.2026.001',
      hazelnutRaw: 'Alune crude în coajă, uscate natural, neprăjite',
      hazelnutDelivery: 'Livrare gratuită prin curier la comenzi de minim 10 kg',
      hazelnutPickup: 'Ridicare personală în Dumbrăvița, județ Timiș',
      hazelnutSeller: 'Vânzător: Adrian Ciuca — fermă de familie',
      provenanceTitle: 'Din livada noastră',
      imagePrev: 'Imaginea anterioară a produsului',
      imageNext: 'Imaginea următoare a produsului'
    },

    productsPage: {
      allProducts: 'Toate Produsele',
      bestsellers: 'Bestsellers',
      newProducts: 'Produse Noi',
      hazelnuts: 'Alune Ecologice',
      snacks: 'Țuică de Alune',
      truffles: 'Trufe Albe',
      gifts: 'Cutii Cadou',
      searchPlaceholder: 'Caută produse...',
      filterSort: 'Filtrează și sortează',
      products: 'produse',
      noProducts: 'Nu s-au găsit produse.',
      defaultSort: 'Sortare implicită',
      sortName: 'Sortează după nume',
      priceLowHigh: 'Preț: Mic la Mare',
      priceHighLow: 'Preț: Mare la Mic',
      sortRating: 'Sortează după rating',
      searchAria: 'Caută produse',
      searchClear: 'Șterge căutarea'
    },

    cartPage: {
      title: 'Coș de Cumpărături',
      empty: 'Coșul tău este gol.',
      continueShopping: 'Continuă Cumpărăturile',
      freeShipping: 'Felicitări! Ai obținut transport gratuit!',
      addMore: 'pentru transport gratuit',
      addPrefix: 'Mai adaugă ',
      subtotal: 'Subtotal',
      shipping: 'Livrare',
      free: 'Gratuită',
      total: 'Total',
      checkout: 'Finalizează Comanda',
      removeItem: 'Elimină produsul',
      qtyDecrease: 'Scade cantitatea',
      qtyIncrease: 'Crește cantitatea',
      checkoutWhatsApp: 'Trimite comanda pe WhatsApp',
      checkoutEmail: 'Trimite comanda pe email',
      orderSummaryHeading: 'Cerere de comandă — deezNuts',
      orderSellerLabel: 'Vânzător',
      orderSellerName: 'Adrian Ciuca',
      orderPickupLabel: 'Ridicare / livrare',
      orderPickupPlace: 'Ridicare personală în Dumbrăvița, județ Timiș, sau livrare prin curier',
      checkoutEmailSubject: 'Cerere de comandă — deezNuts'
    },

    contactPage: {
      title: 'Contact',
      intro: 'Scrie-ne la',
      orCall: 'sau sună la',
      phoneLabel: 'Telefon',
      getInTouch: 'Contactați-ne',
      email: 'Email',
      orchard: 'Livadă',
      location: 'Dumbrăvița, județ Timiș — ridicare personală sau livrare prin curier',
      nameLabel: 'Nume',
      emailLabel: 'Email',
      messageLabel: 'Mesaj',
      sendButton: 'Deschide în WhatsApp',
      sendEmail: 'Deschide în email',
      nameRequired: 'Te rugăm să introduci numele.',
      emailRequired: 'Te rugăm să introduci emailul.',
      emailInvalid: 'Te rugăm să introduci o adresă de email validă.',
      messageRequired: 'Te rugăm să introduci mesajul.',
      openedWhatsApp:
        'Mesajul a fost deschis în WhatsApp. Verifică-l și apasă Trimite — nu l-am primit până nu îl trimiți tu.',
      openedEmail:
        'Mesajul a fost deschis în aplicația de email. Verifică-l și trimite-l — nu l-am primit până nu îl trimiți tu.',
      popupBlocked: 'Browserul a blocat fereastra nouă. Folosește acest link:',
      whatsappLinkLabel: 'Deschide WhatsApp',
      emailLinkLabel: 'Deschide email'
    },

    footer: {
      products: 'Produse',
      hazelnuts: 'Alune Ecologice',
      truffles: 'Trufe Albe',
      snacks: 'Țuică de Alune',
      spreads: 'Creme & Unturi',
      baking: 'Ingrediente pentru Patiserie',
      gifts: 'Cutii Cadou',
      info: 'Informații',
      contact: 'Contactează-ne',
      about: 'Despre Livada Noastră',
      blog: 'Blog',
      terms: 'Termeni și Condiții',
      privacy: 'Politica de Confidențialitate',
      contactTitle: 'Contact',
      newsletter: 'Abonează-te la Newsletter',
      newsletterText: 'Primește oferte exclusive și noutăți despre alune!',
      subscribe: 'Abonează-te',
      thankYou: 'Mulțumim pentru abonare!',
      copyright: '© {year} deezNuts. Toate drepturile rezervate.',
      tagline: '🌰 Alune ecologice din livada noastră, plantată din 2018',
      sellerName: 'Adrian Ciuca',
      sellerSubtitle: 'Fermă de familie · Dumbrăvița, județ Timiș',
      addressLine1: 'Dumbrăvița, județ Timiș',
      addressLine2: 'Ridicare personală sau livrare prin curier'
    },

    aboutPage: {
      eyebrow: 'Livada noastră · Din 2018',
      heroTitle: 'Livada noastră, din 2018',
      heroSubtitle:
        '~2 ha, ~1.100 de aluni — Tonda Gentile Romana și Halle\'s Giant — certificați ecologic',
      heroPills: [
        '🌱 379 aluni (2018) → ~1.100 azi',
        '💧 Irigare prin picurare',
        '✅ Certificat Eco RO-ECO-023'
      ],
      scrubberLabel: 'Explorează anii livezii',
      openPhotoLabel: 'Deschide fotografia',
      galleryCountLabel: 'fotografii',
      lightboxClose: 'Închide galeria',
      lightboxPrev: 'Fotografia anterioară',
      lightboxNext: 'Fotografia următoare',
      timeline: [
        {
          year: '2018',
          title: 'Primii 379 de aluni',
          story:
            'Vara lui 2018 am plantat primii 379 de aluni pe terenul din livada noastră. Fiecare puiet a primit tubul lui de protecție, iar în primele luni au apărut primele frunze.',
          badges: ['🌱 379 aluni plantați'],
          alt: 'Puieți de alun în tuburi de protecție în livada noastră, 2018'
        },
        {
          year: '2019',
          title: 'Livada prinde rădăcini',
          story:
            'Puieții din primul an s-au prins, iar noi am întreținut rândurile toată vara. Toamna am mai plantat 60 de aluni.',
          badges: ['🌱 +60 aluni'],
          alt: 'Rânduri întreținute de aluni tineri în livada noastră, 2019'
        },
        {
          year: '2020',
          title: 'Încă 196 de aluni',
          story:
            'În vara lui 2020 am mai plantat 196 de aluni. Primii puieți au început să arate a tufe, cu seri liniștite și apus peste livadă.',
          badges: ['🌱 +196 aluni'],
          alt: 'Tufe tinere de alun la apus în livada noastră, 2020'
        },
        {
          year: '2021',
          title: 'Cea mai mare plantare: 600 de aluni',
          story:
            'În 2021 am plantat 600 de aluni, cea mai mare plantare de până acum. Livada a ajuns aproape la mărimea de azi.',
          badges: ['🌱 +600 aluni'],
          alt: 'Livada de aluni înfrunzită primăvara și vara, 2021'
        },
        {
          year: '2022',
          title: 'Completări, plopi și irigare',
          story:
            'Primăvara am înlocuit puieții pierduți și am plantat în jur de 110 plopi. Livada are irigare prin picurare, iar pe tufe au apărut primele alune verzi.',
          badges: ['🌳 ~110 plopi', '💧 Irigare prin picurare'],
          alt: 'Primele alune verzi pe tufe și sistemul de irigare, 2022'
        },
        {
          year: '2023',
          title: 'Tufe în toată puterea',
          story:
            'Tufele s-au îndesit, iar rândurile arată deja ca o livadă adevărată. Spre toamnă, primele alune ne-au ajuns în palmă.',
          badges: ['🌿 Livadă formată'],
          alt: 'Rânduri dese de aluni și primele alune în palmă, 2023'
        },
        {
          year: '2024',
          title: 'Prima recoltă',
          story:
            'În 2024 am avut prima recoltă adevărată. Alunele cad sub tufe, iar noi le strângem cu recoltatorul Cifarelli.',
          badges: ['🌰 Prima recoltă'],
          alt: 'Prima recoltă de alune în livada noastră, 2024'
        },
        {
          year: '2025',
          title: 'A doua recoltă',
          story:
            'A doua recoltă a venit cu o livadă tot mai mare. Toamna, tufele se colorează în galben înainte de iarnă.',
          badges: ['🍂 A doua recoltă'],
          alt: 'Livada de aluni în culorile toamnei după a doua recoltă, 2025'
        },
        {
          year: '2026',
          title: 'Eco certificat și deezNuts',
          story:
            'Livada noastră deține certificatul ecologic RO-ECO-023.642-0006300.2026.001 de la Mișcarea Română pentru Calitate (RO-ECO-023), valabil până la 31.12.2027. Alunele se vând sub numele deezNuts, cu pagina de Facebook lansată în 2026. În mai tufele au fost pline de amenți și alune tinere, iar în septembrie recolta a umplut lăzile.',
          badges: [
            '✅ RO-ECO-023.642-0006300.2026.001',
            '📣 Lansare deezNuts pe Facebook'
          ],
          alt: 'Livada certificată ecologic și recolta bogată în lăzi, 2026'
        }
      ],
      cta: {
        eyebrow: 'Certificat Ecologic RO-ECO-023',
        title: 'Comandă alune eco direct din livadă',
        subtitle:
          'Crescute de noi, an de an, în sistem ecologic certificat — soiurile Tonda Gentile Romana și Halle\'s Giant din livada noastră.',
        priceBadge: '45 lei / kg · Comandă minimă 5 kg',
        certBadge:
          'Certificat ecologic RO-ECO-023.642-0006300.2026.001 · Mișcarea Română pentru Calitate (RO-ECO-023) · valabil până la 31.12.2027',
        primaryBtn: 'Comandă alune eco',
        phoneBtn: 'Sună: +40 736 917 034'
      }
    },

    static: {
      blogTitle: 'Blog',
      blogBody: 'Cele mai noi articole vor apărea în curând.',
      termsTitle: 'Termeni și Condiții',
      privacyTitle: 'Politica de Confidențialitate',
      termsParagraphs: [
        'deezNuts este o livadă de familie de aluni administrată de Adrian Ciuca în Dumbrăvița, județ Timiș. Nu există firmă înregistrată (fără SRL/PFA) în spatele acestui site — comenzile sunt gestionate personal.',
        'Produsele din coș sunt cereri de comandă, nu cumpărături automate. Adrian confirmă disponibilitatea, prețul total și detaliile de ridicare sau livrare cu tine pe WhatsApp, telefon sau email înainte de a rezerva ceva.',
        'Acest site nu procesează plăți cu cardul și nu creează conturi de utilizator. Coșul de cumpărături este stocat doar în browserul tău, pe dispozitivul tău (stocare locală), până îl golești sau elimini produse.',
        'Finalizarea comenzii deschide WhatsApp sau aplicația de email cu un rezumat precompletat. Trebuie să verifici mesajul și să îl trimiți tu — nu primim comanda până nu o trimiți.',
        'Livrarea prin curier este disponibilă; comenzile de 10 kg sau mai mult beneficiază de livrare gratuită, conform coșului. Ridicarea personală este în Dumbrăvița, județ Timiș.',
        'Contact: folosește telefonul și emailul de pe pagina Contact, sau scrie-ne pe WhatsApp sau Facebook.'
      ],
      privacyParagraphs: [
        'Acest site este operat de Adrian Ciuca pentru livada de familie deezNuts. Nu avem conturi de utilizator și nici gateway de plată pe site.',
        'Când folosești coșul, alegerile de produse sunt salvate în stocarea locală a browserului tău. Nu primim aceste date decât dacă ne trimiți un rezumat al comenzii pe WhatsApp sau email.',
        'Formularul de contact nu trimite date către serverele noastre. Deschide WhatsApp sau clientul de email cu textul introdus de tine; tu decizi dacă îl trimiți.',
        'Dacă ne contactezi telefonic, pe email, WhatsApp sau Facebook, folosim mesajul doar pentru a răspunde despre comenzi, ridicare sau livrare. Nu vindem datele tale de contact.',
        'Pentru întrebări despre datele tale sau comenzi, contactează-l pe Adrian la emailul și telefonul de pe pagina Contact.'
      ]
    },

    flappyFish: {
      privacyTitle: 'Politica de confidențialitate — Flappy Fish: Sunbeam Reef',
      lastUpdated: 'Ultima actualizare: 24 iulie 2026',
      intro:
        'Flappy Fish: Sunbeam Reef („Aplicația”) este un joc mobil casual. Această pagină este politica de confidențialitate și pagina de suport pentru Aplicație.',
      developerLabel: 'Dezvoltator',
      contactLabel: 'Contact',
      onDeviceTitle: 'Date stocate pe dispozitivul tău',
      onDeviceScores:
        'Scoruri maxime, numele jucătorului, soldul de monede și obiecte din magazin (inimi/scuturi) prin stocare pe dispozitiv (UserDefaults).',
      onDeviceSettings:
        'Setări de joc precum preferințele pentru sunet și feedback haptic.',
      gameCenterTitle: 'Game Center',
      gameCenterBody:
        'Dacă te autentifici în Game Center, Apple poate prelucra numele afișat în Game Center și scorurile pentru clasamentul global. Această prelucrare este reglementată de politica de confidențialitate Apple. Nu operăm un sistem separat de conturi.',
      notDoTitle: 'Ce nu facem',
      notDoAccount: 'Nu cerem crearea unui cont în Aplicație.',
      notDoSell: 'Nu vindem date personale.',
      notDoAds:
        'Nu afișăm rețele publicitare terțe în versiunea actuală.',
      notDoSensitive:
        'Nu colectăm locație precisă, contacte, fotografii sau date de microfon.',
      childrenTitle: 'Copii',
      childrenBody:
        'Aplicația este potrivită pentru un public general. Nu colectăm cu bună știință informații personale de la copii dincolo de ceea ce oferă Game Center Apple dacă un jucător se autentifică.',
      changesTitle: 'Modificări',
      changesBody:
        'Putem actualiza această politică; data „Ultima actualizare” se va schimba când o facem.',
      supportTitle: 'Suport',
      supportBody:
        'Pentru ajutor cu Flappy Fish: Sunbeam Reef, scrie la adresa de mai jos. De obicei răspundem în câteva zile lucrătoare.'
    }
  }
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let result = translations[language] || translations.en;

  for (const k of keys) {
    if (result && result[k] !== undefined) {
      result = result[k];
    } else {
      return key;
    }
  }

  return result;
};

export default translations;
